import React from 'react';
import { findDOMNode } from 'react-dom';
import { inject, observer } from 'mobx-react';
import { toJS } from 'mobx';
import { Modal, Button, Spin, ConfigProvider } from 'antd';
import ApplyApp from '../util/appApply/index';
import validate from '../util/appApply/validate';
import CaseApply from '../util/caseApply/index';
import ThemeItem from './ThemeItem';
import Editor from 'for-editor';
import EcodeLocal from '../ecodeLocal'

const store = [
  'themeListStore',
  'listStore',
  'modeListStore',
  'caseListStore',
]
const {
  checkLicense,
} = validate;
@inject(...store)
@observer
class App extends React.Component {

  constructor(props) {
    super(props);
    this.scrollTop = 0;
    this.state = {
      width: document.body.clientWidth || 1200,
      visible: false,
      markdownValue: ''
    }
  }

  componentDidMount() {
    // if (window.location.hash.indexOf('appId') >= 0) {
    //   const keys = window.location.hash.slice(3).split('&');
    //   keys.forEach(k => {
    //     if (k.indexOf('appId') >= 0) {
    //       this.apply(k.split('=')[1]);
    //     }
    //   })
    // }
    // window.addEventListener('scroll', this.scrollHandler)
    window.addEventListener('resize', this.resizeHandler);
  }

  componentWillUnmount() {
    // window.removeEventListener('scroll', this.scrollHandler)
    window.removeEventListener('resize', this.resizeHandler)
    const { themeListStore } = this.props;
    themeListStore.clear();
  }

  resizeHandler = () => {
    this.setState({ width: document.body.clientWidth });
  }

  scrollHandler = e => {
    if (this.themeList) {
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      const docH = document.documentElement.offsetHeight || document.body.offsetHeight;
      const listH = findDOMNode(this.themeList).offsetHeight
      if (scrollTop > this.scrollTop) { // 向上翻动
        const { themeListStore: { getThemeList, params, pageNum, count, pageSize, loading }, listStore: { params: { searchValue } } } = this.props;
        if (pageNum * pageSize < count && listH - scrollTop + 100 < docH && !loading) {
          getThemeList({ title: searchValue, pageNum: pageNum + 1, pageSize });
        }
      }
      this.scrollTop = scrollTop;
    }
  }
  onFormChange = (values, allValues) => {
    const { modeListStore: { applyLicense, setMobxState, appDetail } } = this.props;
    const data = toJS(appDetail);
    setMobxState({ isApply: false });
    if (Object.keys(values).indexOf('license') >= 0) {
      checkLicense(values.license) && applyLicense({
        sw_id: data.sw_id,
        ec_id: allValues.c_id,
        c_id: allValues.c_id,
        ecname: allValues.c_name,
        license: values.license,
      });
    }
  }

  previewCase = (readme) => {
    this.setState({
      visible: true,
      markdownValue: readme
    });
  }

  onCancel = () => {
    this.setState({visible: false, markdownValue: ''});
  }
  onCaseFormChange = (changed, allValues) => {
    const { caseListStore: { setApply } } = this.props;
    setApply({...changed});
  }

  render() {
    const { visible, markdownValue, width } = this.state;
    const { 
      themeListStore: { themeList }, 
      modeListStore: { appDetail, setMobxState, visibleOfApply }, 
      caseListStore: { setState, applyVisible }
    } = this.props;
    return (
      <div className='home-page-theme'>
        {/* {this.renderItem(themeList)} */}
        {/* <div className="home-page-theme-import" >
          <EcodeLocal
            demoType="portalTheme"
            title="上传门户主题"
          />
        </div> */}
        <ThemeItem 
          version="e9"
          width={width}
          previewCase={this.previewCase}
        />
        <ThemeItem 
          version="e8"
          width={width}
          previewCase={this.previewCase}
        />
        <Modal
            title="预览"
            visible={visible}
            bodyStyle={{
              padding: 0,
              height: 520,
            }}
            style={{
              top: 50,
            }}
            maskClosable={false}
            width={900}
            onCancel={this.onCancel}
            footer={
              <Button type="primary" className="home-page-preview-button" onClick={this.onCancel}>关闭预览</Button>
            }
        >
          {markdownValue ? 
            <Editor
              value={markdownValue}
              preview
              toolbar={{}}
              style={{
                height: '100%',
                borderRadius: 0,
                border: 'none'
              }}
            /> : 
            <Spin><div style={{ width: '100%', height: 500 }} /></Spin>
          }
        </Modal>
        <ApplyApp visible={visibleOfApply}  onChange={(v) => setMobxState({ visibleOfApply: v })} data={toJS(appDetail)} onFormChange={this.onFormChange} />
        <CaseApply visible={applyVisible} onCancel={() => setState({applyVisible: false}) } onFormChange={this.onCaseFormChange} />
      </div>
    )
  }
}

export default App


// WEBPACK FOOTER //
// ./src/components/home/Theme.js